// extracted by mini-css-extract-plugin
export default {"report-attendance__container":"styles_report-attendance__container__XoVaR"};